import { combineEpics, createEpicMiddleware } from 'redux-observable'
import { AuthObservable } from 'auth-advenio'
import Api from '../Api'
import { COOKIE_DOMAIN } from '../../config'
import { companiesEpic } from './CompaniesObservable'
import { companyAccountEpic } from './CompanyAccountObservable'
import { contactsEpic } from './ContactsObservable'
import { contractsEpic } from './ContractsObservable'
import { countriesEpic } from './CountriesObservable'
import { resetPasswordEpic } from './ResetPasswordObservable'
import { usersEpic } from './UsersObservable'
import { consumiblesCategoryEpic } from './ConsumiblesCategoryObservable'
import { RegimenFiscalEpic } from './RegimenFiscalObservable'
import { UsoCFDIEpic } from './UsoCFDIObservable'
import { centersEpic } from './CentersObservable'


const { authEpic } = AuthObservable
const rootEpic = combineEpics(
  authEpic(COOKIE_DOMAIN),
  centersEpic,
  companiesEpic,
  companyAccountEpic,
  contactsEpic,
  contractsEpic,
  countriesEpic,
  resetPasswordEpic,
  usersEpic,
  consumiblesCategoryEpic,
  RegimenFiscalEpic,
  UsoCFDIEpic,
)

export default createEpicMiddleware(rootEpic, {
  dependencies: { Api },
})



// WEBPACK FOOTER //
// ./src/Data/Observables/index.js